import cloneDeep from 'lodash.clonedeep';

import Constants from './constants';
import SvgData from '../data/svgdata';

export function getAlterations(
  option,
  configTypes,
  hideCustomLabels,
  hideSignalChainLabels,
  isSignalChainLinkAlteration,
) {
  let alterations = [];
  const dacAlterationsKey = option.topologySvgName || option.appName,
    dacAlterationsMap = dacAlterationsKey in SvgData.alterations ? SvgData.alterations[dacAlterationsKey] : {};

  if (configTypes && configTypes.length) {
    configTypes.forEach((configType) => {
      if (configType && configType in dacAlterationsMap) alterations.push(...dacAlterationsMap[configType]);
    });
  }

  if (!alterations.length && Constants.SVG.CONFIG.BASE in dacAlterationsMap) {
    alterations = dacAlterationsMap[Constants.SVG.CONFIG.BASE];
  }

  if (Constants.SVG.CONFIG.CUSTOM_LABELS in dacAlterationsMap) {
    const customLabelAlterations = dacAlterationsMap[Constants.SVG.CONFIG.CUSTOM_LABELS].map((alteration) => {
      let result = cloneDeep(alteration);

      if (hideCustomLabels) result.type = Constants.SVG.ALTERATION_TYPES.HIDE;
      else if (hideSignalChainLabels && isSignalChainLinkAlteration(alteration))
        result.type = Constants.SVG.ALTERATION_TYPES.HIDE;

      return result;
    });
    alterations.push(...customLabelAlterations);
  }

  return alterations;
}

export function makeSvgStylesUnique(svgElement, selectorId) {
  if (!(svgElement && (selectorId || svgElement.id))) return;

  const styleElement = svgElement.querySelector('style'),
    useSelectorId = selectorId || svgElement.id;

  let styleRules = parseStyleElement(styleElement);

  // Don't do anything if it's already been done
  if (styleRules.every((styleRule) => styleRule.selector.includes(selectorId))) return;

  styleRules.forEach(
    (styleRule) =>
      (styleRule.selector = styleRule.selector
        .split(',')
        .map((selectorItem) =>
          selectorItem.includes(useSelectorId) ? selectorItem : `#${useSelectorId} ${selectorItem}`,
        )
        .join(',')),
  );

  modifyStyleElement(styleRules, styleElement);
}

export function modifyStyleElement(styleRules, styleElement) {
  if (!styleElement) return;

  let styleString = styleRules
    .map((styleRule) => {
      const propertiesString = Object.keys(styleRule.properties)
        .map((propertyName) => `${propertyName}:${styleRule.properties[propertyName]};`)
        .join('');
      return `${styleRule.selector}{${propertiesString}}`;
    })
    .join('');

  styleElement.innerHTML = styleString;
}

export function parseStyleElement(styleElement) {
  if (!styleElement) return [];

  // .cls-1{font-size:6.06px;}.cls-1,.cls-10,.cls-11,.cls-5{fill:#231f20;}.cls-1,.cls-10,.cls-11{font-family:Arial-BoldMT, Arial;font-weight:700;}.cls-2,.cls-4,.cls-6,.cls-8,.cls-9{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-7,.cls-8,.cls-9{stroke:#010101;}.cls-2,.cls-3,.cls-4,.cls-7,.cls-8{stroke-miterlimit:14.3;}.cls-2,.cls-3,.cls-4,.cls-8,.cls-9{stroke-width:0.75px;}.cls-2,.cls-9{fill-rule:evenodd;}.cls-3{fill:none;}.cls-5{font-size:9px;font-family:MyriadPro-Regular, Myriad Pro;}.cls-7{fill:#010101;stroke-width:0.5px;}.cls-8{stroke-linecap:square;}.cls-10{font-size:6px;}.cls-11{font-size:8px;}
  let styleString = styleElement.innerHTML,
    rules = styleString ? styleString.split('}') : [];

  return rules
    .map((rule) => {
      const ruleItems = rule.split('{');

      if (ruleItems.length > 1) {
        const selector = ruleItems[0];
        let properties = ruleItems[1].split(';'),
          propertyMap = {};

        properties.forEach((property) => {
          const propertyItems = property.split(':');

          if (propertyItems.length > 1) {
            const propertyName = propertyItems[0],
              propertyValue = propertyItems[1];

            propertyMap[propertyName] = propertyValue;
          }
        });

        return {
          selector: selector,
          properties: propertyMap,
        };
      }
    })
    .filter((rule) => rule);
}

export function getSignalChainComponent(componentName) {
  return document.querySelector(`.dac-svg .${componentName}`);
}
